module.exports = __webpack_public_path__ + "static/media/sesa.3c46481f.png";